import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RouterParamSeervice } from 'src/app/service/params/params.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-account-deletion-success',
    templateUrl: './account-deletion-success.component.html',
    styleUrls: ['./account-deletion-success.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountDeletionSuccessComponent {
  redirectUrl: string = '';
  isocode: string = '';
  countryCode: string = '';
  backToApp: boolean = false;
  image: string = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public params: RouterParamSeervice,
    private translation: TranslateService
  ) {
    this.isocode =  translation.currentLang ?? 'en';
    if(this.isocode === 'en'){
      window.location.href = environment.notFoundUrl;
    }
    this.countryCode = this.isocode.split('-')[1];
    this.route.queryParams.subscribe((params) => {
      if (params['redirectUrl'] != null) {
        this.backToApp = true;
        this.redirectUrl = params['redirectUrl'];
      } else {
        this.backToApp = false;
      }
    });
  }
  login() {
    if (this.backToApp) {
      window.location.href = 'https://' + this.redirectUrl;
    } else {
      window.location.href = environment.mykaercher + '/' + this.isocode;
    }
  }

  toHomepage() {
    window.location.href =
      environment.corporateUrl + '/' + this.countryCode.toLowerCase();
  }
}
